// client/marks/color.ts
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex";
import "@adornis/chemistry/elements/components/x-icon";
import { html, nothing } from "lit";
import { COLOR_KEY, COLOR_SCHEMA } from "../../schema/marks/color.js";
import { toggleMark } from "../helper/toggleMark.js";
import { MenuItemGroup } from "../types.js";
import { isInText } from "../util.js";
var color = () => ({
  mark: {
    name: COLOR_KEY,
    schema: COLOR_SCHEMA()
  }
});
var colorMenuItem = (color2) => {
  let selectedColor = color2;
  return {
    group: MenuItemGroup.COLOR,
    label: selectedColor ?? "Farbe ausw\xE4hlen",
    render(editorView) {
      if (selectedColor === void 0)
        return html`
          <x-input
            ${css({ width: "50px" })}
            type="color"
            @value-picked=${(e) => {
          e.preventDefault();
          e.stopPropagation();
          selectedColor = e.detail.value;
          const transaction = editorView.state.tr.setMeta("forceUpdate", true);
          editorView.dispatch(transaction);
        }}
          >
            set red
          </x-input>
        `;
      const isActive = this.isActive?.(editorView) ?? false;
      return html`
        <x-flex ${css(isActive ? { background: "#F2F2F1", padding: "8px" } : {})} style="position: relative;">
          <x-flex
            ${css({
        boxSizing: "border-box",
        width: isActive ? "16px" : "32px",
        aspectRatio: "1 / 1",
        border: isActive ? "" : "2px solid #333",
        background: selectedColor,
        borderRadius: "4px",
        cursor: "pointer"
      })}
          >
          </x-flex>
          ${color2 === void 0 ? html`
                <x-icon
                  @click=${() => {
        selectedColor = void 0;
      }}
                >
                  close
                </x-icon>
              ` : nothing}
        </x-flex>
      `;
    },
    run: (view) => {
      toggleMark({ markName: COLOR_KEY, view, attrs: { color: selectedColor } })(view.state, view.dispatch);
    },
    shouldVisualize: (view) => {
      return isInText(view.state);
    },
    isActive: (view) => {
      return toggleMark({ markName: COLOR_KEY, view, attrs: { color: selectedColor } })(view.state);
    }
  };
};
export {
  color,
  colorMenuItem
};
